'use strict';

var _has2 = _interopRequireDefault(require("lodash/has"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (darc) {
  darc.addType({
    name: 'set',
    getDefault: function getDefault() {
      return {};
    },
    create: function create(model) {
      var array = [model];
      array.$ = {
        isSet: true
      };
      return array;
    }
  });

  darc.isSchemaASet = function (schema) {
    return (0, _has2.default)(schema, '$.isSet');
  };
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS90eXBlcy9zZXQuanMiXSwibmFtZXMiOlsibW9kdWxlIiwiZXhwb3J0cyIsImRhcmMiLCJhZGRUeXBlIiwibmFtZSIsImdldERlZmF1bHQiLCJjcmVhdGUiLCJtb2RlbCIsImFycmF5IiwiJCIsImlzU2V0IiwiaXNTY2hlbWFBU2V0Iiwic2NoZW1hIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7O0FBSUFBLE9BQU9DLE9BQVAsR0FBaUIsVUFBVUMsSUFBVixFQUFpQjtBQUVqQ0EsT0FBS0MsT0FBTCxDQUFjO0FBRWJDLFVBQU0sS0FGTztBQUliQyxnQkFBWSxzQkFBVztBQUV0QixhQUFPLEVBQVA7QUFFQSxLQVJZO0FBVWJDLFlBQVEsZ0JBQVVDLEtBQVYsRUFBa0I7QUFFekIsVUFBSUMsUUFBUSxDQUFFRCxLQUFGLENBQVo7QUFDQUMsWUFBTUMsQ0FBTixHQUFVO0FBQ1RDLGVBQU87QUFERSxPQUFWO0FBR0EsYUFBT0YsS0FBUDtBQUVBO0FBbEJZLEdBQWQ7O0FBc0JBTixPQUFLUyxZQUFMLEdBQW9CLGtCQUFVO0FBRTdCLFdBQU8sbUJBQU9DLE1BQVAsRUFBZSxTQUFmLENBQVA7QUFFQSxHQUpEO0FBTUEsQ0E5QkQiLCJzb3VyY2VzQ29udGVudCI6WyIndXNlIHN0cmljdCc7XG5cbmltcG9ydCBfIGZyb20gJ2xvZGFzaCc7XG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oIGRhcmMgKSB7XG5cblx0ZGFyYy5hZGRUeXBlKCB7XG5cblx0XHRuYW1lOiAnc2V0JyxcblxuXHRcdGdldERlZmF1bHQ6IGZ1bmN0aW9uKCkge1xuXG5cdFx0XHRyZXR1cm4ge307XG5cblx0XHR9LFxuXG5cdFx0Y3JlYXRlOiBmdW5jdGlvbiggbW9kZWwgKSB7XG5cblx0XHRcdGxldCBhcnJheSA9IFsgbW9kZWwgXTtcblx0XHRcdGFycmF5LiQgPSB7XG5cdFx0XHRcdGlzU2V0OiB0cnVlXG5cdFx0XHR9O1xuXHRcdFx0cmV0dXJuIGFycmF5O1xuXG5cdFx0fVxuXG5cdH0gKTtcblxuXHRkYXJjLmlzU2NoZW1hQVNldCA9IHNjaGVtYSA9PiB7XG5cblx0XHRyZXR1cm4gXy5oYXMoIHNjaGVtYSwgJyQuaXNTZXQnICk7XG5cblx0fTtcblxufTsiXX0=